// Module
var code = `<toaster-container toaster-options="{'time-out': 5000, 'close-button':true, 'animation-class': 'toast-top-center'}">

</toaster-container>

<div id="page-wrapper" ng-class="{'open': toggle}" ng-cloak>

    <div ui-view="sidebar" ></div>

    <div id="content-wrapper">
        <div class="page-content">
            <div class="row header" ui-view="content-header"></div>
            <div ui-view></div>
        </div>
    </div>
</div>`;
// Exports
module.exports = code;